/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelBrTrackingDocTypeMap.ts          *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/br-tracking-doc-type-map";

export class AutogenModelBrTrackingDocTypeMap<RowType extends ModelRow> extends Endpoint<RowType, RowBrTrackingDocTypeMapFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowBrTrackingDocTypeMap extends ModelRow<RowBrTrackingDocTypeMapFields> {
	constructor(values?: Partial<RowBrTrackingDocTypeMapFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowBrTrackingDocTypeMapFields {
	company_id: string;
	id: string;
	lme_doc_type: string;
	vendor_doc_type: string;
	vendor_id: string;
}

